import { createContext, useEffect, useReducer } from 'react';
import { PROFILE_IMAGE, TREEVIEW } from '@contexts/common-reducer/actions';
import commonReducer, { initialCommonState } from '@contexts/common-reducer/common';
import { endpoints } from '@api/_users';
import axios from '@utils/axios';
import { dataURLtoBlob } from '@utils/dataURLtoBlob';

const CommonContext = createContext({
  ...initialCommonState,
  handleTreeView: (id) => Promise.resolve(),
  selectedTreeItem: (id) => Promise.resolve(),
  uploadUserProfile: (e) => Promise.resolve()
});

export const CommonProvider = ({ children }) => {
  const [state, dispatch] = useReducer(commonReducer, initialCommonState);

  const handleTreeView = async (treeView) => {
    dispatch({
      type: TREEVIEW,
      payload: {
        treeView
      }
    });
  };
  const selectedTreeItem = async (selectedTreeItem) => {
    dispatch({
      type: TREEVIEW,
      payload: {
        selectedTreeItem
      }
    });
  };

  const getUserProfile = async () => {
    try {
      const url = `${endpoints.key}${endpoints.profile}`;
      const { status, data } = await axios.get(url);
      const blob = dataURLtoBlob(data.result.profileImageBase64);
      dispatch({
        type: PROFILE_IMAGE,
        payload: { profileImage: blob }
      });
    } catch (error) {}
  };
  const uploadUserProfile = async (file) => {
    try {
      dispatch({
        type: PROFILE_IMAGE,
        payload: { profileImage: file }
      });
      const formData = new FormData();
      formData.append('file', file);
      const url = `${endpoints.key}/upload-profile`;
      const { status, data } = await axios.post(url, formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      });

      console.info(data);
    } catch (error) {}
  };
  useEffect(() => {
    const serviceToken = window.localStorage.getItem('serviceToken');

    // Skip profile calls for anonymous sessions to avoid auth redirects on public routes.
    if (!serviceToken) return;

    getUserProfile();
  }, []);
  return <CommonContext value={{ ...state, handleTreeView, selectedTreeItem, uploadUserProfile }}>{children}</CommonContext>;
};

export default CommonContext;
